"use client";

import { useEffect, useRef } from "react";

import {
  buildAddToCartEcommercePayload,
  buildEcommerceEvent,
} from "@/lib/analytics/ecommerce-analytics";
import { getItemListOrigin } from "@/lib/analytics/item-list-context";
import { ProductLineItemModel } from "@/lib/basket/productLineItem.model";

import { EVENTS } from "@/constants/analytics.constants";
import { useTagging } from "@/hooks/useTagging";

export function AddToCartEvent({
  kits,
  accessories,
  monitoring,
  tax,
  shipping,
  addedProductId,
}: AddToCartEventProps) {
  const [, setTag] = useTagging();
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current) return;
    firedRef.current = true;

    const origin = getItemListOrigin();
    const payload = buildAddToCartEcommercePayload(
      { kits, accessories, monitoring },
      {
        addedProductId,
        tax,
        shipping,
        item_list_id: origin?.item_list_id,
        item_list_name: origin?.item_list_name,
      },
    );

    setTag(buildEcommerceEvent(EVENTS.ADD_TO_CART, payload), { reset: true });
  }, [kits, accessories, monitoring, tax, shipping, addedProductId, setTag]);

  return null;
}

type AddToCartEventProps = {
  kits: ProductLineItemModel[];
  accessories: ProductLineItemModel[];
  monitoring: ProductLineItemModel | null;
  tax: number;
  shipping: number;
  addedProductId?: string;
};
